/**
 * Published blog post path segments under `/blog/:slug`.
 *
 * Kept client-safe (no markdown imports) so public-path allowlists can fail
 * closed for unknown slugs. The catalog in `#worker/blog/catalog.ts` owns the
 * post bodies; its node test asserts every catalog slug appears here.
 */
export const blogPostSlugs = [
	'ai-agent-audit-log-for-production-access',
	'ai-agent-credentials-guide-for-team-leads',
	'ai-agent-github-access-without-your-token',
	'ai-agent-guardrails-for-teams',
	'ai-agent-skills-vs-packages',
	'ai-tooling-for-engineering-teams-hidden-cost',
	'avoid-ai-assistant-lock-in',
	'bring-your-own-key-for-shared-team-tools',
	'claude-code-cursor-and-codex-shared-credentials',
	'early-kody-users',
	'engineers-are-handing-private-keys-to-ai-agents',
	'every-install-is-a-fork-you-own',
	'gateways-connect-homes-accumulate',
	'how-to-roll-out-ai-agents-to-your-team',
	'how-to-turn-agent-work-into-software-you-own',
	'internal-tools-built-with-ai-team-credentials',
	'kody-weekly-2026-03-20',
	'kody-weekly-2026-03-27',
	'kody-weekly-2026-04-03',
	'kody-weekly-2026-04-10',
	'kody-weekly-2026-04-17',
	'kody-weekly-2026-04-24',
	'kody-weekly-2026-05-01',
	'kody-weekly-2026-05-08',
	'kody-weekly-2026-05-15',
	'kody-weekly-2026-05-22',
	'kody-weekly-2026-05-29',
	'kody-weekly-2026-06-05',
	'kody-weekly-2026-06-12',
	'kody-weekly-2026-06-19',
	'kody-weekly-2026-06-26',
	'kody-weekly-2026-07-03',
	'kody-weekly-2026-07-10',
	'kody-weekly-2026-07-17',
	'kody-weekly-2026-07-24',
	'kody-weekly-2026-07-31',
	'kody-weekly-2026-08-07',
	'kody-weekly-2026-08-14',
	'kody-weekly-2026-08-21',
	'kody-weekly-2026-08-28',
	'kody-weekly-2026-09-04',
	'kody-weekly-2026-09-11',
	'kody-weekly-2026-09-18',
	'kody-weekly-2026-09-25',
	'kody-weekly-2026-10-02',
	'kody-weekly-2026-10-09',
	'kody-weekly-2026-10-16',
	'kody-weekly-2026-10-23',
	'kody-weekly-2026-10-30',
	'least-privilege-for-ai-agents',
	'mcp-security-checklist-for-engineering-managers',
	'openclaw-2-needs-a-home',
	'revoke-ai-agent-access',
	'self-service-means-ownership',
	'share-ai-workflows-with-your-team',
	'team-ai-workflows-when-someone-quits',
	'the-assistant-that-cant-leak-your-keychain',
	'the-automations-you-never-built',
	'where-to-store-api-keys-for-ai-agents',
	'why-ai-agent-costs-keep-growing',
	'why-aws-lambda-breaks-down-for-ai-agent-teams',
	'your-assistants-home',
	'zero-inference-calls',
] as const
